<ng-container *ngIf="teaType; else loader">
  <div *ngIf="errors.length > 0" class="m-2">
    <div class="bg-red-500 text-white p-4 rounded">
      <h2 class="text-xl font-bold">Something went wrong:</h2>
      <ul>
        <li *ngFor="let error of errors">{{ error }}</li>
      </ul>
    </div>
  </div>
  <div class="m-2">
    <h1 class="text-center text-3xl font-bold text-green-900">{{ teaType.name }}</h1>
    <div class="pt-5 flex justify-center">
      <img [src]="teaLadyAssetPath | imageModifier:{width:600} | async" alt="" class="" style="width: 300px;">
    </div>
    <!-- <div class="pt-5 text-lg markdown" [innerHTML]="teaType.description |markdown | async">
    </div> -->

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-5">
      <tea-shop-fe-tea-item-summary *ngFor="let tea of teas" [teaItem]="tea"></tea-shop-fe-tea-item-summary>
    </div>
  </div>
</ng-container>

<ng-template #loader>
  <div class="m-2">
    <div class="animate-pulse">
      <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/6 mb-2"></div>
    </div>
  </div>
</ng-template>
